import { countriesActions } from "../../actionTypes";

const initialState = {
	cities: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case countriesActions.FETCH_CITIES: {
			return { ...state, fetching: true };
		}

		case countriesActions.FETCH_CITIES_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				cities: action.payload,
			};
		}

		case countriesActions.FETCH_CITIES_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
			return state;
	}
};
export default Reducer;
